import { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export const languages = [
	{ code: "pl", label: "Polski", flag: "🇵🇱" },
	{ code: "en", label: "English", flag: "🇬🇧" },
];

export const LanguageProvider = ({ children }) => {
	const { i18n } = useTranslation();
	const [language, setLanguage] = useState(i18n.language || "pl");

	const changeLanguage = (code) => {
		setLanguage(code);
		i18n.changeLanguage(code);
	};

	useEffect(() => {
		const handleLanguageChanged = (lng) => {
			setLanguage(lng);
		};
		
		i18n.on('languageChanged', handleLanguageChanged);
		
		return () => {
			i18n.off('languageChanged', handleLanguageChanged);
		};
	}, [i18n]);

	return (
		<LanguageContext.Provider value={{ language, changeLanguage, languages }}>
			{children}
		</LanguageContext.Provider>
	);
};

export const useLanguage = () => {
	const context = useContext(LanguageContext);
	if (!context) {
		throw new Error('useLanguage must be used within a LanguageProvider');
	}
	return context;
};
